import * as Oazapfts from 'oazapfts/lib/runtime'
import { defaults } from '@/api'

const oazapfts = Oazapfts.runtime(defaults)

/*
 * Session « en tant que » ouverte depuis la console (TEC-1911, ADR 0044 du backend). Écrit à la main : la copie
 * de `nabuAPI1.0.json` de ce dépôt est en retard sur le contrat, la régénérer embarquerait d'autres changements.
 */

/** Échange le code à usage unique de la console contre le jeton, rendu dans l'en-tête `Authorization`. */
export function callImpersonationExchange(
  code: string,
  opts?: Oazapfts.RequestOpts
) {
  return oazapfts.fetchJson<
    | { status: 200; data: { session?: string; expiresAt?: string } }
    | { status: 400 }
    | { status: 401 }
    | { status: number }
  >(
    '/account/impersonation/exchange',
    oazapfts.json({ ...opts, method: 'POST', body: { code } })
  )
}

/** « Terminer » : la gateway ferme la session, le jeton ne passe plus. */
export function callImpersonationEnd(opts?: Oazapfts.RequestOpts) {
  return oazapfts.ok(
    oazapfts.fetchText('/account/impersonation/end', {
      ...opts,
      method: 'POST',
    })
  )
}
